import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { OTC_SUPPORT_EMAIL } from '@/constants/otc'
import { trackOtcSupportContacted, type OtcScreen } from '@/utils/analytics'

type OtcContactSupportProps = {
  screen: OtcScreen
}

const OtcContactSupportComponent = ({ screen }: OtcContactSupportProps) => {
  const { t } = useTranslation()
  const handleContactClick = useCallback(
    () => trackOtcSupportContacted(screen),
    [screen]
  )

  return (
    <p className="text-sm text-gray-500" data-testid="text-otc-contact-support">
      {t('otc.contact.prompt')}{' '}
      <a
        href={`mailto:${OTC_SUPPORT_EMAIL}`}
        className="underline"
        onClick={handleContactClick}
        data-testid="link-otc-contact-support"
      >
        {OTC_SUPPORT_EMAIL}
      </a>
      .
    </p>
  )
}

export const OtcContactSupport = React.memo(OtcContactSupportComponent)
